<template>
  <div id="numberedMode">
    <div class="tip_box">
      <span class="title" v-text="title"></span>
      <span class="tip" v-text="tip"></span>
    </div>
  </div>
</template>

<script>
// 只要是 platfromMode==mixtmt_h5 即显示
export default {
  name: 'numberedMode',
  data() {
    return {
      title: '暂不支持小屏设备和竖屏预览',
      tip: '提示：请使用电脑或ipad等大屏设备横屏预览，谢谢!',
    }
  },
}
</script>

<style lang="scss" scoped>
#numberedMode {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  .tip_box {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 80%;
    color: #fff;
    .title {
      font-size: 3.472vw;
      font-weight: bold;
    }
    .tip {
      font-size: 2.778vw;
      line-height: 5.55vw;
    }
  }
}
</style>
